var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/answer-icons/call-features/features-all.svg": "f623",
	"./assets/answer-icons/call-features/features-barring.svg": "9ac3",
	"./assets/answer-icons/call-features/features-circle.svg": "594d",
	"./assets/answer-icons/call-features/features-conference.svg": "88ba",
	"./assets/answer-icons/call-features/features-display.svg": "ebe3",
	"./assets/answer-icons/call-features/features-diversion.svg": "04b6",
	"./assets/answer-icons/call-features/features-phone.svg": "5047",
	"./assets/answer-icons/call-features/features-ring-back.svg": "8414",
	"./assets/answer-icons/call-features/features-waiting.svg": "7028",
	"./assets/answer-icons/call-types/call-types-all.svg": "74a0",
	"./assets/answer-icons/call-types/call-types-bg.svg": "3c04",
	"./assets/answer-icons/call-types/call-types-incoming.svg": "616d",
	"./assets/answer-icons/call-types/call-types-international.svg": "de0a",
	"./assets/answer-icons/call-types/call-types-landline.svg": "087b",
	"./assets/answer-icons/call-types/call-types-mobile.svg": "780d",
	"./assets/answer-icons/internet-times/all.svg": "5fb8",
	"./assets/answer-icons/internet-times/bg.svg": "b64d",
	"./assets/answer-icons/internet-times/day-evening-night.svg": "3187",
	"./assets/answer-icons/internet-times/day-evening.svg": "d996",
	"./assets/answer-icons/internet-times/day-night.svg": "3a30",
	"./assets/answer-icons/internet-times/day.svg": "2e58",
	"./assets/answer-icons/internet-times/evening-night.svg": "91af",
	"./assets/answer-icons/internet-times/evening.svg": "1735",
	"./assets/answer-icons/internet-times/night.svg": "99cf",
	"./assets/answer-icons/multiple-lines/all.svg": "d250",
	"./assets/answer-icons/multiple-lines/bg.svg": "f737",
	"./assets/answer-icons/multiple-lines/multiple.svg": "98705",
	"./assets/answer-icons/speed/bar1.svg": "2643",
	"./assets/answer-icons/speed/bar2.svg": "e787",
	"./assets/answer-icons/speed/bar3.svg": "9690",
	"./assets/answer-icons/speed/bar4.svg": "68d9",
	"./assets/answer-icons/speed/bg.svg": "6514",
	"./assets/answer-icons/speed/indicator.svg": "6b02",
	"./assets/answer-icons/transfer/transfer-all.svg": "4543",
	"./assets/answer-icons/transfer/transfer-audio.svg": "e27c",
	"./assets/answer-icons/transfer/transfer-bg.svg": "6449",
	"./assets/answer-icons/transfer/transfer-documents.svg": "7043",
	"./assets/answer-icons/transfer/transfer-else.svg": "111a",
	"./assets/answer-icons/transfer/transfer-photos.svg": "379b",
	"./assets/answer-icons/transfer/transfer-videos.svg": "448c",
	"./assets/answer-icons/user-count/all.svg": "3984",
	"./assets/answer-icons/user-count/back_1.svg": "707c",
	"./assets/answer-icons/user-count/back_15.svg": "d326",
	"./assets/answer-icons/user-count/back_4.svg": "8b51",
	"./assets/answer-icons/user-count/back_9.svg": "52ae",
	"./assets/answer-icons/user-count/circle.svg": "baa7",
	"./assets/answer-icons/user-count/fore_1.svg": "59d6",
	"./assets/answer-icons/user-count/fore_15.svg": "332d",
	"./assets/answer-icons/user-count/fore_4.svg": "d16c",
	"./assets/answer-icons/user-count/fore_9.svg": "4c04",
	"./assets/answer-icons/user-count/laptop.svg": "2637",
	"./assets/chat/provider-logos/bt.svg": "2b21",
	"./assets/chat/provider-logos/daisy.svg": "dd1a",
	"./assets/chat/provider-logos/ee.svg": "f722",
	"./assets/chat/provider-logos/focus.svg": "7bb8",
	"./assets/chat/provider-logos/plusnet.svg": "feae",
	"./assets/chat/provider-logos/talktalk.svg": "e86a",
	"./assets/data/__mocks__/questionData": "74b3",
	"./assets/data/__mocks__/questionData.js": "74b3",
	"./assets/data/bank-holidays": "8f92",
	"./assets/data/bank-holidays.json": "8f92",
	"./assets/data/products": "9c07",
	"./assets/data/products.json": "9c07",
	"./assets/data/products/appFeatures": "03f1",
	"./assets/data/products/appFeatures.js": "03f1",
	"./assets/data/products/handSetProducts": "bb2c",
	"./assets/data/products/handSetProducts.js": "bb2c",
	"./assets/data/questionData-bionic": "e05a",
	"./assets/data/questionData-bionic.js": "e05a",
	"./assets/data/questionData-ctm": "256c",
	"./assets/data/questionData-ctm.js": "256c",
	"./assets/icons/arrow.svg": "21e2",
	"./assets/icons/blue-lock.svg": "03e3",
	"./assets/icons/broadband-only.svg": "6462",
	"./assets/icons/broadband-phone.svg": "0927",
	"./assets/icons/broadband-result-high.svg": "737b",
	"./assets/icons/broadband-result-low.svg": "8262",
	"./assets/icons/broadband-result-medium.svg": "2f8b",
	"./assets/icons/call-circle.svg": "6919",
	"./assets/icons/check-circle-purple.svg": "82e8",
	"./assets/icons/check-circle.svg": "cfcb",
	"./assets/icons/ctm-both-selected.svg": "8691",
	"./assets/icons/ctm-both.svg": "df12",
	"./assets/icons/ctm-broadband-selected.svg": "071c",
	"./assets/icons/ctm-broadband.svg": "0e61",
	"./assets/icons/ctm-call-circle.svg": "5ece",
	"./assets/icons/ctm-check-circle.svg": "d132",
	"./assets/icons/ctm-phone-selected.svg": "9519",
	"./assets/icons/ctm-phone.svg": "1fe8",
	"./assets/icons/cyan-phone.svg": "569e",
	"./assets/icons/down-arrow.svg": "fcc4",
	"./assets/icons/lock.svg": "9619",
	"./assets/icons/next-arrow.svg": "73f4",
	"./assets/icons/no-voip.svg": "3fad",
	"./assets/icons/orange-tilt-phone.svg": "36cc",
	"./assets/icons/phone-icon.svg": "8f38",
	"./assets/icons/phone-only.svg": "a554",
	"./assets/icons/phone-result.svg": "f810",
	"./assets/icons/popup-book.svg": "1c6b",
	"./assets/icons/radio-icon-checked-navy.svg": "2442",
	"./assets/icons/radio-icon-inactive.svg": "b36c",
	"./assets/icons/right-product.svg": "edf4",
	"./assets/icons/tick.svg": "812c",
	"./assets/icons/use-voip.svg": "6b5f",
	"./assets/icons/white-tick.svg": "f9ec",
	"./assets/images/Features_Screen1.png": "c581",
	"./assets/images/Features_Screen2.png": "8254",
	"./assets/images/Laptop.png": "5436",
	"./assets/images/VoipApp.png": "1d29",
	"./assets/images/agents-circle.png": "0d17",
	"./assets/images/agents.png": "1403",
	"./assets/images/choose.svg": "b079",
	"./assets/images/laptop-apps.png": "3644",
	"./assets/images/mobile-apps.png": "b7ed",
	"./assets/images/products/handsets/Cisco_6821.png": "c0fee",
	"./assets/images/products/handsets/Cisco_6841-51-61-71.png": "d918",
	"./assets/images/products/handsets/Cisco_8841.png": "edfb",
	"./assets/images/products/handsets/Cisco_8851.png": "77a6",
	"./assets/images/products/handsets/Cisco_8861.png": "4c5f",
	"./assets/images/products/handsets/Polycom_150.png": "ed84",
	"./assets/images/products/handsets/Polycom_250.png": "c3a6",
	"./assets/images/products/handsets/Polycom_450.png": "e022",
	"./assets/images/products/handsets/Polycom_600.png": "f0c7",
	"./assets/images/products/handsets/Polycom_8500.png": "2d01",
	"./assets/images/products/handsets/Polycom_8800.png": "65b4",
	"./assets/images/products/handsets/Yealink_w52p.png": "ff16",
	"./assets/images/takecare.svg": "d1cf",
	"./assets/images/usage.svg": "18de",
	"./assets/logos/partners/confused-logo.svg": "fc4f",
	"./assets/logos/partners/msm-logo.png": "adf0",
	"./assets/logos/partners/uswitch-logo.png": "c559",
	"./assets/logos/suppliers/bt/black.svg": "df56",
	"./assets/logos/suppliers/bt/colour.svg": "6c49",
	"./assets/logos/suppliers/bt/navy.svg": "bba1",
	"./assets/logos/suppliers/bt/white.svg": "e724",
	"./assets/logos/suppliers/daisy/black.svg": "7457",
	"./assets/logos/suppliers/daisy/colour.svg": "f65b",
	"./assets/logos/suppliers/daisy/navy.svg": "f3d9",
	"./assets/logos/suppliers/daisy/white.svg": "8062",
	"./assets/logos/suppliers/ee/black.svg": "ae3f",
	"./assets/logos/suppliers/ee/color.svg": "50ce",
	"./assets/logos/suppliers/ee/navy.svg": "821f",
	"./assets/logos/suppliers/focus/black.svg": "d274",
	"./assets/logos/suppliers/focus/color.svg": "7cdf",
	"./assets/logos/suppliers/focus/navy.svg": "f82c",
	"./assets/logos/suppliers/plusnet/black.svg": "2168",
	"./assets/logos/suppliers/plusnet/colour.svg": "8f8e",
	"./assets/logos/suppliers/plusnet/navy.svg": "5b76",
	"./assets/logos/suppliers/plusnet/white.svg": "1976",
	"./assets/logos/suppliers/sky/colour.svg": "cc34",
	"./assets/logos/suppliers/sky/navy.png": "480d",
	"./assets/logos/suppliers/sky/white.svg": "a34c",
	"./assets/logos/suppliers/talktalk/black.svg": "7bfd",
	"./assets/logos/suppliers/talktalk/color.svg": "0f13",
	"./assets/logos/suppliers/talktalk/navy.svg": "e9c5",
	"./assets/logos/suppliers/virgin/colour.svg": "c17f",
	"./assets/logos/suppliers/virgin/navy.svg": "3e3e",
	"./assets/logos/suppliers/virgin/white.svg": "930b",
	"./assets/logos/suppliers/xln/colour.svg": "9527",
	"./assets/logos/suppliers/xln/navy.svg": "7a88",
	"./assets/logos/suppliers/xln/white.svg": "db41",
	"./assets/scss/_bionic_variables.scss": "9ef1",
	"./assets/scss/_ctm_variables.scss": "6572",
	"./assets/scss/_variables.scss": "fb51",
	"./assets/scss/theme.scss": "7d32",
	"./assets/scss/tooltip.scss": "d2b2",
	"./components/cdc/CheckList": "9565",
	"./components/cdc/CheckList.vue": "9565",
	"./components/chat/ChatPartnerIcons": "8726",
	"./components/chat/ChatPartnerIcons.vue": "8726",
	"./components/cookies/CookieConsent": "2b95",
	"./components/cookies/CookieConsent.vue": "2b95",
	"./components/home/AboutBlock": "9f0c",
	"./components/home/AboutBlock.vue": "9f0c",
	"./components/home/CallBanner": "0916",
	"./components/home/CallBanner.vue": "0916",
	"./components/home/FooterBlock": "0575",
	"./components/home/FooterBlock.vue": "0575",
	"./components/home/HeroBlock": "48b2",
	"./components/home/HeroBlock.vue": "48b2",
	"./components/home/HowItWorks": "fffd",
	"./components/home/HowItWorks.vue": "fffd",
	"./components/home/ProviderBlock": "8a87",
	"./components/home/ProviderBlock.vue": "8a87",
	"./components/home/SupplierRow": "8c7c",
	"./components/home/SupplierRow.vue": "8c7c",
	"./components/home/TwoRowBlock": "94bf",
	"./components/home/TwoRowBlock.vue": "94bf",
	"./components/icons/ArrowIcon": "7034",
	"./components/icons/ArrowIcon.vue": "7034",
	"./components/icons/ChevronIcon": "3ec4",
	"./components/icons/ChevronIcon.vue": "3ec4",
	"./components/icons/CircleIcon": "da9f",
	"./components/icons/CircleIcon.vue": "da9f",
	"./components/icons/CrossIcon": "e47f",
	"./components/icons/CrossIcon.vue": "e47f",
	"./components/icons/PopUpSVG": "dc9a",
	"./components/icons/PopUpSVG.vue": "dc9a",
	"./components/icons/TickIcon": "1881",
	"./components/icons/TickIcon.vue": "1881",
	"./components/icons/answer/AnswerIcon": "e6a6",
	"./components/icons/answer/AnswerIcon.vue": "e6a6",
	"./components/icons/answer/CallFeaturesIcon": "4120",
	"./components/icons/answer/CallFeaturesIcon.vue": "4120",
	"./components/icons/answer/InternetSpeedIcon": "2904",
	"./components/icons/answer/InternetSpeedIcon.vue": "2904",
	"./components/icons/answer/PhoneLinesIcon": "bed4",
	"./components/icons/answer/PhoneLinesIcon.vue": "bed4",
	"./components/icons/answer/TimeOfDayIcon": "b2ab",
	"./components/icons/answer/TimeOfDayIcon.vue": "b2ab",
	"./components/icons/answer/TransfersIcon": "fba7",
	"./components/icons/answer/TransfersIcon.vue": "fba7",
	"./components/icons/answer/TypeOfCallsIcon": "907f",
	"./components/icons/answer/TypeOfCallsIcon.vue": "907f",
	"./components/icons/answer/UserCountIcon": "6bc2",
	"./components/icons/answer/UserCountIcon.vue": "6bc2",
	"./components/messages/AnswerMessage": "025c",
	"./components/messages/AnswerMessage.vue": "025c",
	"./components/messages/MapMessage": "3ad3",
	"./components/messages/MapMessage.vue": "3ad3",
	"./components/messages/ScoreMessage": "b4b3",
	"./components/messages/ScoreMessage.vue": "b4b3",
	"./components/messages/SingleMessage": "1b7b",
	"./components/messages/SingleMessage.vue": "1b7b",
	"./components/messages/TitleMessage": "404b",
	"./components/messages/TitleMessage.vue": "404b",
	"./components/products/HandsetProduct": "b646",
	"./components/products/HandsetProduct.vue": "b646",
	"./components/progress/AnswerProgressDrawer": "2824",
	"./components/progress/AnswerProgressDrawer.vue": "2824",
	"./components/progress/ProgressBar": "8dd1",
	"./components/progress/ProgressBar.vue": "8dd1",
	"./components/progress/ProgressDrawer": "707a",
	"./components/progress/ProgressDrawer.vue": "707a",
	"./components/question/QuestionTitle": "b98c",
	"./components/question/QuestionTitle.vue": "b98c",
	"./components/question/inputs/CheckList": "9849",
	"./components/question/inputs/CheckList.vue": "9849",
	"./components/question/inputs/ChoiceBox": "7e36",
	"./components/question/inputs/ChoiceBox.vue": "7e36",
	"./components/question/inputs/DesktopMobileApp": "781d",
	"./components/question/inputs/DesktopMobileApp.vue": "781d",
	"./components/question/inputs/ImageCounter": "5460",
	"./components/question/inputs/ImageCounter.vue": "5460",
	"./components/question/inputs/ImageCounters": "f546",
	"./components/question/inputs/ImageCounters.vue": "f546",
	"./components/question/inputs/RadioList": "35cc",
	"./components/question/inputs/RadioList.vue": "35cc",
	"./components/question/inputs/SearchDropdown": "6aa8",
	"./components/question/inputs/SearchDropdown.vue": "6aa8",
	"./components/question/inputs/SummaryEdit": "2042",
	"./components/question/inputs/SummaryEdit.vue": "2042",
	"./components/question/inputs/SupplierSelection": "9870",
	"./components/question/inputs/SupplierSelection.vue": "9870",
	"./components/question/inputs/VOIPSelection": "fd00",
	"./components/question/inputs/VOIPSelection.vue": "fd00",
	"./components/svg/icons/ConferencePhoneSVG": "0911",
	"./components/svg/icons/ConferencePhoneSVG.vue": "0911",
	"./components/svg/icons/ConfirmationSVG": "dc2d",
	"./components/svg/icons/ConfirmationSVG.vue": "dc2d",
	"./components/svg/icons/CordlessPhoneSVG": "cad5",
	"./components/svg/icons/CordlessPhoneSVG.vue": "cad5",
	"./components/svg/icons/DeskPhoneSVG": "4883",
	"./components/svg/icons/DeskPhoneSVG.vue": "4883",
	"./components/svg/icons/DesktopMobileAppUsersSVG": "ce55",
	"./components/svg/icons/DesktopMobileAppUsersSVG.vue": "ce55",
	"./components/svg/icons/LocationsSVG": "ac4c",
	"./components/svg/icons/LocationsSVG.vue": "ac4c",
	"./components/typography/InPageLink": "943e",
	"./components/typography/InPageLink.vue": "943e",
	"./components/typography/InPageTitle": "739a",
	"./components/typography/InPageTitle.vue": "739a",
	"./components/typography/SubTitle": "4a48",
	"./components/typography/SubTitle.vue": "4a48",
	"./components/ui/CardBox": "f60a",
	"./components/ui/CardBox.vue": "f60a",
	"./components/ui/InputNumericBox": "3ad0",
	"./components/ui/InputNumericBox.vue": "3ad0",
	"./components/ui/PopupBox": "a7a9",
	"./components/ui/PopupBox.vue": "a7a9",
	"./components/ui/PopupClickArea": "9420",
	"./components/ui/PopupClickArea.vue": "9420",
	"./components/ui/SelectOptionBox": "8bb9",
	"./components/ui/SelectOptionBox.vue": "8bb9",
	"./components/ui/ToggleBox": "b9eb",
	"./components/ui/ToggleBox.vue": "b9eb",
	"./components/ui/buttons/CompactButton": "72cf",
	"./components/ui/buttons/CompactButton.vue": "72cf",
	"./components/ui/cards/ProductCard": "a250",
	"./components/ui/cards/ProductCard.vue": "a250",
	"./constants/duplicated-content": "5043",
	"./constants/duplicated-content.js": "5043",
	"./constants/notes-descriptions": "8269",
	"./constants/notes-descriptions.js": "8269",
	"./constants/question-ids": "a198",
	"./constants/question-ids.js": "a198",
	"./constants/question-options": "310b",
	"./constants/question-options.js": "310b",
	"./helpers/NotasPayloadBuilder": "d816",
	"./helpers/NotasPayloadBuilder.js": "d816",
	"./helpers/NotesEncoder": "06e1",
	"./helpers/NotesEncoder.js": "06e1",
	"./helpers/ObjectToString": "a887",
	"./helpers/ObjectToString.js": "a887",
	"./helpers/ifArrIncludes": "1b7f",
	"./helpers/ifArrIncludes.js": "1b7f",
	"./helpers/isAnObject": "7b88",
	"./helpers/isAnObject.js": "7b88",
	"./helpers/sorting/sortDescending": "6f50",
	"./helpers/sorting/sortDescending.js": "6f50",
	"./main": "56d7",
	"./main.js": "56d7",
	"./mixins/Accumulative": "9480",
	"./mixins/Accumulative.js": "9480",
	"./mixins/Utag": "837e",
	"./mixins/Utag.js": "837e",
	"./revision": "f642",
	"./revision.json": "f642",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/guards": "e8f8",
	"./router/guards.js": "e8f8",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./store/questions": "c37e",
	"./store/questions.js": "c37e",
	"./store/sessionsWarehouse": "bc74",
	"./store/sessionsWarehouse.js": "bc74",
	"./views/CallbackConfirmation": "4663",
	"./views/CallbackConfirmation.vue": "4663",
	"./views/ConfirmationPage": "8ddf",
	"./views/ConfirmationPage.vue": "8ddf",
	"./views/ContactDetailsCapture": "7348",
	"./views/ContactDetailsCapture.vue": "7348",
	"./views/Error": "dda8",
	"./views/Error.vue": "dda8",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/NotFoundPage": "0c8b",
	"./views/NotFoundPage.vue": "0c8b",
	"./views/QuestionPage": "ccec",
	"./views/QuestionPage.vue": "ccec",
	"./views/ResultsPage": "c813",
	"./views/ResultsPage.vue": "c813"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";